import { BaseColumn, EditableGrid, Schema } from "../core/components/editableGrid/editableGrid.js";
import { ExtendedProjectFilterEntity } from "./extendedProjectFilter.js";
import {
    GridCustomToolBarButton,
    ToolBar,
    ToolBarStandardButton,
    ToolBarStandardButtonType
} from "../core/components/toolBar.js";
import { Helper } from "../core/util/helper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Config } from "../core/config/config.js";
import { General } from "../../siteManagement/general.js";
import React from "react";
export class ExtendedProjectFilterHistory extends React.Component<ExtendedProjectFilterHistoryProps, ExtendedProjectFilterHistoryState>{
    private editableGridRef: EditableGrid;
    constructor(props: ExtendedProjectFilterHistoryProps | Readonly<ExtendedProjectFilterHistoryProps>) {
        super(props);
        this.state = {
            Columns: [],
            Schema: null
        };
    }
    private isSelected = () => {
        return this.editableGridRef?.hasSelected();
    }
    private sthIsDeactivated = () => {
        return this.editableGridRef?.getSelectedItemsArray()?.filter((s: any) => !s.Active).length > 0;
    }
    private onSelectionChange = () => {
        this.setState({});
    }
    private handleStandardButtonClick = (button: ToolBarStandardButtonType) => {
        if(button === ToolBarStandardButtonType.DELETE){
            DialogHelper.confirm(Config.translations.deleteMessage).then(isOk => {
                if(isOk){
                    let selectedItems: any[] = this.editableGridRef.getSelectedItemsArray();
                    let itemsCopy: any[] = JSON.parse(JSON.stringify(this.props.GridData));
                    selectedItems.forEach((item: any) => {
                        let index = itemsCopy.findIndex(i => i.Projnr === item.Projnr);
                        if(index > -1){
                            itemsCopy.splice(index, 1);
                        }
                    });
                    this.props.updateItems(itemsCopy);
                }
            })
        }
    }
    private handleCustomButtonClick = (buttonId: string) => {
        if(buttonId === "activate"){
            let changedItems = JSON.parse(JSON.stringify(this.props.GridData));
            const selected: any[] = this.editableGridRef.getSelectedItemsArray() as any[];
            let newActiveValue = this.sthIsDeactivated();
            selected.forEach((item: any) => {
                let currentItem = changedItems.find(i => i.Projnr == item.Projnr);
                if(currentItem){
                    currentItem.Active = newActiveValue;
                }
            });
            this.props.updateItems(changedItems);
        }
        if(buttonId === "allActivate"){
            let changedItems = JSON.parse(JSON.stringify(this.props.GridData));
            changedItems.forEach((item: any) => {
                item.Active = true;
            });
            this.props.updateItems(changedItems);
        }
        if(buttonId === "allDeactivate"){
            let changedItems = JSON.parse(JSON.stringify(this.props.GridData));
            changedItems.forEach((item: any) => {
                item.Active = false;
            });
            this.props.updateItems(changedItems);
        }
    }
    private renderLabel = (text: string) => {
        if(Helper.isNullOrEmpty(text))
            return null;
        return (<p style={{backgroundColor: "rgb(255,241,157)", color: "rgb(106,91,0)", width: "max-content", borderRadius:"var(--border-radius)", border: "2px solid rgba(0, 0, 0, 0.25)", padding: "5px", marginBottom: "5px"}}>{text}</p>);
    }
    render(){

        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: this.isSelected()})
        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({
            id: "activate",
            enabled: this.isSelected(),
            caption:  Helper.getTranslation(this.sthIsDeactivated() && this.isSelected() ? "Standard.Aktivieren" : "Standard.Deaktivieren"),
            iconClass: this.sthIsDeactivated() && this.isSelected() ? "k-i-check" : "k-i-close",
            autoEnabledOnRecordSelected: false
        });
        customButtons.push({
            id: "allActivate",
            enabled: this.props.GridData?.length > 0,
            caption: Helper.getTranslation("WebSMS.DataExchangeModule.File.ActivateAll"),
            iconClass: "far fa-check-double",
            autoEnabledOnRecordSelected: false
        });
        customButtons.push({
            id: "allDeactivate",
            enabled: this.props.GridData?.length > 0,
            caption: Helper.getTranslation("Projekt.DeactivateAll"),
            iconClass: "far fa-empty-set",
            autoEnabledOnRecordSelected: false
        });
        let projectFilterNotActive = null;
        let favoriteFilterWarning = null;
        let height = 0;
        height += 4;
        if(Helper.hasValue(this.props.FavoriteFilterId)){
            height += 58 + 8;
            projectFilterNotActive = this.renderLabel(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.NotActiveReason").replace("{filterName}", this.props.FavoriteFilterName));
            favoriteFilterWarning = this.renderLabel(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.Advice"));
        }
        
        let sheet = General.Sheet.Manager.getTopMostVisibleSheet();
        height += ($('#container').get()[0].offsetTop < 0 ? $('#container').get()[0].offsetTop * -1 : $('#container').get()[0].offsetTop);
        height += sheet.elements.getTitleRef().closest('.sheet__title').get()[0].offsetHeight;
        let fields = sheet.elements.getContentRef().find('div.field-instance');
        if (fields.length > 0) {
            height += fields[fields.length - 1].getBoundingClientRect().top + 5;
        }
        
        return <>
            {this.renderLabel(this.props.limit ? Helper.getTranslation("Projekt.ProjectfilterWarning").replace("{count}", this.props.limit?.toString()) : "")}
            {projectFilterNotActive}
            {favoriteFilterWarning}
            <ToolBar standardButtons={standardButtons} handleStandardButtonClick={this.handleStandardButtonClick}
                     customButtons={customButtons} handleCustomButtonClick={this.handleCustomButtonClick}/>
            <div id={"projectFilterHistoryWrapper"} style={{height: "calc(-" + height + "px + 100vh)"}}><EditableGrid
                id={"projectFilterHistory"}
                data={this.props.GridData}
                gridOptions={this.props.GridOptions}
                ref={ref => this.editableGridRef = ref}
                validatable={false}
                sortable={true}
                editable={false}
                selectable={false}
                groupable={false}
                pageable={true}
                scrollable={true}
                showSelectableCheckBox={true}
                onSelectionChange={this.onSelectionChange}
                {...this.props}
                selectableCheckBoxHeaderTemplate={Helper.getTranslation("Suche.Selection")}
            /></div>
        </>
    }
}

export interface ExtendedProjectFilterHistoryProps{
    GridData: any[];
    GridOptions: any;
    entity: ExtendedProjectFilterEntity;
    updateItems(items);
    limit?: number;
    FavoriteFilterName?: string;
    FavoriteFilterId?: string;
}
interface ExtendedProjectFilterHistoryState{
    Schema: Schema;
    Columns: BaseColumn[];
}